import { AlertDialogComponent } from '../alert/alert.component';
import { Component } from '@angular/core';

@Component({
  selector: 'upload-errors-dialog',
  templateUrl: 'upload-errors.component.html'
})
export class UploadErrorsDialogComponent extends AlertDialogComponent {
  constructor() {
    super();
  }

  initDialog() {
    super.initDialog();
  }

  closeAlert() {
    super.closeAlert();
  }
}
